import React from 'react';
import {Checkbox} from "mindsets-js-sdk";

import BaseComponentProperty from "../index";

export default class Speech extends BaseComponentProperty {
    renderLeft() {
        if (!!this.props.component.data.left) {
            return (
                <div>
                    <div>
                        <label>Bubble color</label>
                        <input
                            type='text'
                            value={this.props.component.data.left && this.props.component.data.left.bubble_background ? this.props.component.data.left.bubble_background : ''}
                            onChange={event => {
                                let data = this.props.component.data;
                                data.left.bubble_background = event.target.value;
                                this.props.onChange('data', data);
                            }}
                        />
                    </div>
                    <div>
                        <label>Html</label>
                        <textarea
                            value={this.props.component.data.left && this.props.component.data.left.text ? this.props.component.data.left.text : ''}
                            onChange={event => {
                                let data = this.props.component.data;
                                data.left.text = event.target.value;
                                this.props.onChange('data', data);
                            }}
                        />
                    </div>
                </div>
            );
        }

        return null;
    }

    renderRight() {
        if (!!this.props.component.data.right) {
            return (
                <div>
                    <div>
                        <label>Bubble color</label>
                        <input
                            type='text'
                            value={this.props.component.data.right && this.props.component.data.right.bubble_background ? this.props.component.data.right.bubble_background : ''}
                            onChange={event => {
                                let data = this.props.component.data;
                                data.right.bubble_background = event.target.value;
                                this.props.onChange('data', data);
                            }}
                        />
                    </div>
                    <div>
                        <label>Html</label>
                        <textarea
                            value={this.props.component.data.right && this.props.component.data.right.text ? this.props.component.data.right.text : ''}
                            onChange={event => {
                                let data = this.props.component.data;
                                data.right.text = event.target.value;
                                this.props.onChange('data', data);
                            }}
                        />
                    </div>
                </div>
            );
        }

        return null;
    }

    renderOwnProperties() {
        return (
            <div>
                <div>
                    <label>Image</label>
                    <textarea
                        value={this.props.component.data.image && this.props.component.data.image.src ? this.props.component.data.image.src : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            if (!data.image) {
                                data.image = {};
                            }
                            data.image.src = event.target.value;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Image alt</label>
                    <textarea
                        value={this.props.component.data.image && this.props.component.data.image.image_alt ? this.props.component.data.image.image_alt : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            if (!data.image) {
                                data.image = {};
                            }
                            data.image.image_alt = event.target.value;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Direction</label>
                    <select
                        value={this.props.component.config && this.props.component.config.direction ? this.props.component.config.direction : ''}
                        onChange={event => {
                            let config = this.props.component.config;
                            if (!config) {
                                config = {};
                            }
                            config.direction = event.target.value;
                            this.props.onChange('config', config);
                        }}
                    >
                        <option value=''>Select Direction</option>
                        <option value='horizontal'>Horizontal</option>
                        <option value='vertical'>Vertical</option>
                    </select>
                </div>
                <div>
                    <div className='bordered'>
                        <Checkbox
                            label='Left'
                            toggle={() => {
                                let data = this.props.component.data;
                                if (data.left) {
                                    delete data.left;
                                } else {
                                    data.left = {
                                        text: ''
                                    }
                                }
                                this.props.onChange('data', data);
                            }}
                            checked={!!this.props.component.data.left}
                        />
                        {this.renderLeft()}
                    </div>
                    <div className='bordered'>
                        <Checkbox
                            label='Right'
                            toggle={() => {
                                let data = this.props.component.data;
                                if (data.right) {
                                    delete data.right;
                                } else {
                                    data.right = {
                                        text: ''
                                    }
                                }
                                this.props.onChange('data', data);
                            }}
                            checked={!!this.props.component.data.right}
                        />
                        {this.renderRight()}
                    </div>
                </div>
            </div>
        );
    }
}
